var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"root",staticClass:"plugin-home-hero-text-item",class:{ _half: _vm.isHalf }},[_c('div',{staticClass:"plugin-home-hero-text-item__observer"},[_c('common-intersection-observer',{attrs:{"options":{ threshold: 0.8 },"self-destruct":""},on:{"intersect":_vm.triggerImpressionAnalytics}})],1),_c('div',{staticClass:"plugin-home-hero-text-item__text",class:`_${_vm.textAlign}`,style:({
            color: _vm.textColor,
            backgroundColor: _vm.backgroundColor,
        }),domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }